import { render, staticRenderFns } from "./mailboxSwitch.vue?vue&type=template&id=104b9a8d&scoped=true"
import script from "./mailboxSwitch.vue?vue&type=script&lang=js"
export * from "./mailboxSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b9a8d",
  null
  
)

export default component.exports